import { render, staticRenderFns } from "./Error500.vue?vue&type=template&id=6cbc160e&scoped=true&"
import script from "./Error500.vue?vue&type=script&lang=js&"
export * from "./Error500.vue?vue&type=script&lang=js&"
import style0 from "./Error500.vue?vue&type=style&index=0&id=6cbc160e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc160e",
  null
  
)

export default component.exports